interface Props {
  current: number;
  total: number;
}

export function ProgressBar({ current, total }: Props) {
  const percent = Math.round(((current + 1) / total) * 100);

  return (
    <div className="w-full px-4 py-2">
      <div className="flex justify-between items-center mb-1">
        <span className="text-xs font-semibold text-hit-gray-mid uppercase tracking-wider">
          Pregunta {current + 1} de {total}
        </span>
        <span className="text-xs font-semibold text-hit-gold">{percent}%</span>
      </div>
      <div className="w-full h-1.5 bg-hit-dark rounded-full overflow-hidden">
        <div
          className="h-full bg-hit-gold rounded-full transition-all duration-500 ease-out"
          style={{ width: `${percent}%` }}
          role="progressbar"
          aria-valuenow={current + 1}
          aria-valuemin={1}
          aria-valuemax={total}
          aria-label={`Pregunta ${current + 1} de ${total}`}
        />
      </div>
    </div>
  );
}
